import React from 'react';
import styled from 'styled-components';
import {
  maxWidth, primaryFont, retina, wMBold,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #CECECE;
  margin-bottom: 20px;
  .table-item {
    padding-top: 17px;
    padding-bottom: 17px;
    font-weight: ${wMBold};
    color: #3F4B50;
    font-size: 16px;
    font-family: ${primaryFont};
    letter-spacing: -0.45px;
    &:nth-child(1) {
      width: 7%;
      text-align:center;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 6%;
        padding-left: 10px;
      }
    }
    &:nth-child(2) {
      width: 7%;
      text-align:center;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 8%;
        padding-left: 20px;
      }
    }
    &:nth-child(3) {
      width: 22%;
      padding-right: 10%;
      text-align: center;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 27%;
        text-align: center;
        padding-right: 5.5%;
      }
    }
    &:nth-child(4) {
      width: 48%;
      text-align:left;
    }
    &:nth-child(5) {
      width: 16%;
      text-align:center;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 20%;
      }
    }
  }
`;

const Bullets = styled.div`
  padding: 0 20px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .bullet-item {
    color: #424B50;
    font-weight: ${wMBold};
    font-size: 12px;
    letter-spacing: -0.3px;
    display: flex;
    align-items: center;
    margin: 0px 10px;
    white-space: nowrap;
    @media all and (max-width: ${maxWidth}) , ${retina} {
        white-space: nowrap;
    }
    .bullet {
      height: 12px;
      width: 12px;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
`;

const TeamChartHeader = function TeamChartHeader() {
  return (
    <Wrapper className="table-head">
      <div className="table-item">Rank</div>
      <div className="table-item">Belt</div>
      <div className="table-item">Name</div>
      <div className="table-item">Usage</div>
      <div className="table-item">
        <Bullets>
          <span className="bullet-item">
            <span className="bullet" style={{ backgroundColor: '#1D8AD2' }} />
            xiQ App
          </span>
          <span className="bullet-item">
            <span className="bullet" style={{ backgroundColor: '#FECB03' }} />
            Daily IQ Email
          </span>
          <span className="bullet-item">
            <span className="bullet" style={{ backgroundColor: '#18C351' }} />
            Notifications
          </span>
        </Bullets>
      </div>
    </Wrapper>
  );
};

export default TeamChartHeader;
